import { FaArrowRight, FaCheck } from "react-icons/fa6";
import Reveal from "@/components/site/Reveal";
import { CHAPTERS, IMAGES, WHATSAPP_LINK } from "@/data/content";

const highlights = [
  "Industry Expertise across IT, Non-IT, BFSI & Healthcare",
  "Quality Hiring with multi-tier candidate screening",
  "Faster Recruitment reducing time-to-fill by up to 40%",
  "Long-Term Partnerships with 95%+ client retention",
  "Customized Hiring Solutions tailored to company goals",
];

const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative overflow-hidden bg-white py-24 md:py-36"
    >
      <div className="mx-auto max-w-[1300px] px-6 md:px-10">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-20">
          {/* Left: sticky intro + image */}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <Reveal>
                <p className="mb-4 flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.25em] text-gold-primary">
                  <span className="h-px w-8 bg-gold-primary" /> About PLACE8
                </p>
                <h2 className="font-display text-4xl font-extralight leading-[1.05] tracking-tightest text-green-primary md:text-5xl">
                  Connecting Exceptional Talent with
                  <span className="italic text-gradient-gold"> Exceptional Companies.</span>
                </h2>
                <p className="mt-6 text-base leading-relaxed text-green-primary md:text-lg font-medium">
                  PLACE8 is a premier recruitment consultancy specializing in
                  connecting ambitious organizations with high-performing
                  professionals. From C-suite executive search to large-scale
                  bulk hiring, we partner with companies to build teams that
                  drive sustainable business growth.
                </p>
              </Reveal>

              <Reveal delay={0.15} className="mt-8 overflow-hidden rounded-3xl shadow-luxe border border-gold-soft">
                <div className="group relative">
                  <img
                    src={IMAGES.about}
                    alt="PLACE8 Recruitment Consultancy Corporate Workspace"
                    loading="lazy"
                    decoding="async"
                    width="1200"
                    height="800"
                    className="h-64 w-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105 md:h-80"
                  />
                  <div className="absolute bottom-5 left-5 bg-white/95 backdrop-blur-md rounded-2xl px-5 py-4 shadow-luxe border border-gold-soft">
                    <p className="text-3xl font-bold text-green-primary">5000+</p>
                    <p className="text-[11px] font-bold uppercase tracking-widest text-gold-primary">
                      Successful Placements
                    </p>
                  </div>
                </div>
              </Reveal>
            </div>
          </div>

          {/* Right: manifesto chapters + highlight bullets */}
          <div className="lg:col-span-7">
            <div className="flex flex-col">
              {/* Highlight checklist */}
              <Reveal className="rounded-3xl border border-gold-soft bg-gold-light p-8 shadow-soft mb-10">
                <h3 className="font-display text-2xl font-light text-green-primary mb-5">
                  Why Leading Organizations Trust Us
                </h3>
                <div className="grid grid-cols-1 gap-4">
                  {highlights.map((item, idx) => (
                    <div key={idx} className="flex items-start gap-3">
                      <span className="mt-1 grid h-5 w-5 shrink-0 place-items-center rounded-full bg-gold-primary text-[10px] text-white font-bold">
                        <FaCheck />
                      </span>
                      <span className="text-sm font-semibold text-green-primary">
                        {item}
                      </span>
                    </div>
                  ))}
                </div>
              </Reveal>

              {CHAPTERS.map((c, i) => (
                <Reveal
                  key={c.no}
                  delay={i * 0.08}
                  className={`flex gap-6 py-8 md:gap-10 ${
                    i !== CHAPTERS.length - 1 ? "border-b border-gold-soft/60" : ""
                  }`}
                >
                  <span className="font-display text-2xl font-light text-gold-primary md:text-3xl">
                    {c.no}
                  </span>
                  <div>
                    <h3 className="font-display text-2xl font-light tracking-tight text-green-primary md:text-3xl">
                      {c.title}
                    </h3>
                    <p className="mt-3 text-base leading-relaxed text-green-primary font-medium">
                      {c.body}
                    </p>
                  </div>
                </Reveal>
              ))}

              <Reveal delay={0.1} className="pt-10">
                <a
                  data-testid="about-cta"
                  href={WHATSAPP_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-center gap-3 text-xs md:text-sm font-bold uppercase tracking-[0.14em] text-green-primary hover:text-gold-primary transition-colors"
                >
                  Schedule a Recruitment Strategy Call
                  <span className="grid h-10 w-10 place-items-center rounded-full btn-gold text-white transition-transform duration-300 group-hover:translate-x-1 shadow-soft">
                    <FaArrowRight className="text-xs" />
                  </span>
                </a>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
